import { all } from 'redux-saga/effects';
import CalendarSaga from './CalendarSaga.jsx';
export default function* rootSaga() {
    yield all([CalendarSaga()]);
}
